import { RoleEntity } from '@/modules/Users/types/role';
import { useTranslation } from 'react-i18next';

type RoleColumnProps = {
  roleName: string;
  roleEntity?: RoleEntity;
};

export const RoleColumn = ({ roleName, roleEntity }: RoleColumnProps) => {
  const { t } = useTranslation();
  return (
    <div className="overflow-hidden text-ellipsis">
      {t(`roles.${roleName}`, { entity: roleEntity && t(roleEntity) })}
    </div>
  );
};
